/* eslint-disable no-restricted-globals */
import { css } from '@emotion/css'
import html2pdf from "html2pdf.js"
import { useEffect, useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import { BaseComponentWithContextProps, componentWithContext } from '../../../base/customHooks/componentHOC'
import { exportToXLSX, exportToXLSXVDFMultipleColumns, formatCurrencyTemlik, printElement } from '../../../base/utils/dataHelper'
import InputCampaign from '../../../components/InputCampaign'
import IPButton from '../../../components/IPButton'
import IPPrintButton from '../../../components/IPPrintButton'
import IPSelectBox from '../../../components/IPSelectBox'
import { ISelectOption } from '../../../components/IPSelectBox/IPSelectBox'
import Table from '../../../components/Table'
import { GetCompaniesApi } from '../../../layouts/components/client/services/getCompaniesApi'
import {
  BasketTransactionResponse,
  CreditCardPrintPdfDetailRequest,
  CreditCardTransactionsRequest,
  CreditCardTransactionsResponse,
} from './creditCardOperationsModel'
import { creditCardOperationsService } from './creditCardOperationsService'
import { basketOperationsService } from './basketOperationsService'
import moment from 'moment'

function CreditCardOperations(props: BaseComponentWithContextProps) {
  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setHours(0)
  inititalStartDate.setMinutes(0)
  inititalStartDate.setSeconds(0)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())
  const [transactions, setTransactions] = useState<CreditCardTransactionsResponse[]>([])
  const [basketTransactions, setBasketTransactions] = useState<BasketTransactionResponse[]>([])
  const [optionList, setOptionList] = useState<any>({
    companyOptions: [],
  })
  const [companyValue, setCompanyValue] = useState<ISelectOption | null>(null)
  const [pdfHtml, setPdfHtml] = useState<string>("");
  const [actionType, setActionType] = useState('');

  const getCompanies = async () => {
    const res = await new GetCompaniesApi({}).getCompanyApi()
    if (res) {
      const data: any = []
      if (res.length > 1) {
        data.push({ value: '', label: 'Hepsi' })
      }
      res.forEach(item => {
        if (item.Name === 'Index Group') return
        data.push({ value: item.Code, label: item.Name })
      })
      setCompanyValue(res.length === 1 ? data[0] : undefined)
      setOptionList({ companyOptions: data })
    }
  }

  const handlePrint = (documentNumber, company, transactionNumber, Iyzico: boolean) => {
    creditCardPrintPdfDetail(documentNumber, company, transactionNumber, "print", Iyzico);
  };

  const handleDownload = (documentNumber, company, transactionNumber, Iyzico: boolean) => {
    creditCardPrintPdfDetail(documentNumber, company, transactionNumber, "download", Iyzico);
  };


  const creditCardPrintPdfDetail = async (docNumber: string, company: string, tkNumber: string, action: string, Iyzico: boolean) => {
    const req: CreditCardPrintPdfDetailRequest = {
      Company: company,
      TransactionNumber: docNumber,
      OrderNumber: tkNumber,
      Type: 2,
    }
    try {
      let res: string;
      if (Iyzico) {
        res = await new creditCardOperationsService({}).creditCardPrintPdfDetailIyzico(req)
      } else {
        res = await new creditCardOperationsService({}).creditCardPrintPdfDetail(req)
      }

      if (res) {
        setPdfHtml(res); // HTML içeriğini state'e kaydet
        setActionType(action); // Hangi aksiyon yapılacağını belirle
      } else {
        throw new Error("Sunucudan geçerli bir yanıt alınamadı.");
      }
    } catch (err: any) {
      Swal.fire('Hata', err.description, 'error')
    }
  }

  useEffect(() => {
    if (pdfHtml && actionType) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(pdfHtml, "text/html");

      if (!doc) {
        console.error("Failed to parse the HTML content");
        return;
      }

      if (actionType === "print") {
        printElement(doc.body); // Print the entire body content
      } else if (actionType === "download") {
        html2pdf()
          .set({
            margin: 10,
            filename: "document.pdf",
            jsPDF: {
              unit: "mm",
              format: "a4",
              orientation: "portrait",
              // Yüksek çözünürlük için dpi değeri artırılıyor
              compression: true,
              image: { type: 'jpeg', quality: 1 },  // Kaliteyi artırmak için
              scale: 3, // Görüntü çözünürlüğünü artırmak için
            }
          })
          .from(doc.documentElement) // Use entire HTML content
          .save();
      }
      setPdfHtml(""); // Clear state after action
      setActionType("")
    }
  }, [pdfHtml, actionType]); // Runs when pdfHtml or actionType updates

  useEffect(() => {
    getCompanies()
    creditCardTransactions()
  }, [])

  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(' ', 'T')
  }

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const dateToISO = date => new Date(new Date(date).getTime() + 3 * 3600 * 1000)

  const popupCenter = ({ url, title, w, h, data }) => {
    // Fixes dual-screen position                             Most browsers      Firefox
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height

    const systemZoom = width / window.screen.availWidth
    const left = (width - w) / 2 / systemZoom + dualScreenLeft
    const top = (height - h) / 2 / systemZoom + dualScreenTop
    const newWindow = window.open(
      url,
      title,
      `
      scrollbars=yes,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `
    )
    newWindow?.document.write(data)
    // @ts-ignore
    if (window.focus) newWindow.focus()
  }

  const creditCardTransactions = async () => {
    props.showLoading()
    const req: CreditCardTransactionsRequest = {
      Company: companyValue ? companyValue?.value?.toString() : '',
      StartDate: dateToISO(startDate),
      EndDate: dateToISO(endDate),
    }
    // Ödeme (payment) hareketleri
    try {
      const paymentResult = await new creditCardOperationsService({}).creditCardTransactions(req)
      setTransactions(paymentResult ?? [])
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
    // Sepet (basket) hareketleri
    try {
      const basketResult = await new basketOperationsService({}).basketTransactions(req)
      setBasketTransactions(basketResult ?? [])
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
    props.hideLoading()
  }

  const sendCreditCardCancellationEmail = async (docNumber: string, company: string, tkNumber: string) => {
    Swal.fire({
      icon: 'question',
      title: 'İşlemi iptal etmek istediğinize emin misiniz?',
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed) {
        const req: CreditCardPrintPdfDetailRequest = {
          Company: company,
          TransactionNumber: docNumber,
          OrderNumber: tkNumber,
          Type: 2,
        }
        try {
          const res = await new creditCardOperationsService({}).sendCreditCardCancellationEmail(req)
          if (res) {
            Swal.fire('Bilgi', 'İptal maili iletilmiştir.', 'info')
            setTransactions(prev =>
              prev.map(x => {
                if (x.DocumentNumber === docNumber) {
                  x.CancelEmail = true
                }
                return x
              })
            )
          }
        } catch (err: any) {
          Swal.fire('Hata', err.description, 'error')
        }
      }
    })
  }

  const excelButton = async () => {
    try {
      if (transactions) {
        const data: any[] = []
        if (transactions.length > 0) {
          transactions.map(item => {
            return data.push({
              'İşlem Tarihi': item.TransactionDate && moment(item.TransactionDate).format('DD.MM.YYYY HH:mm:ss'),
              'İşlem No': item.TransactionNumber,
              'Ödeme Tipi': item.TransactionType,
              Banka: item.BankName,
              'Adı Soyadı': item.CCName.toUpperCase(),
              'Toplam Tutar': formatCurrencyTemlik(parseFloat(item.TotalPrice.replaceAll('.', '').replace(',', '.'))),
              Taksit:
                item.Installment && item.Installment === '0'
                  ? 'Tek Çekim'
                  : item.Installment === '1'
                    ? 'Tek Çekim'
                    : item.Installment + ' Taksit',
              'Taksit Tutar': formatCurrencyTemlik(parseFloat(item.InstallmentPrice.replaceAll('.', '').replace(',', '.'))),
              'Para Birimi': item.Currency ?? 'TL',
              'Kur Bilgisi': item.CurrencyData
                ? item.Currency === 'USD'
                  ? `USD: ${item.CurrencyData.Usd ? parseFloat(item.CurrencyData.Usd.replace(',', '.')).toFixed(4) : '0.0000'
                  }`
                  : item.Currency === 'EUR'
                    ? `EUR: ${item.CurrencyData.Eur ? parseFloat(item.CurrencyData.Eur.replace(',', '.')).toFixed(4) : '0.0000'
                    }`
                    : '-'
                : '-',
              'Ödenen': item.RealPrice ?? '-',
              'Makbuz No': item.DocumentNumber,
              '3D': item.ThreedPaymentState ? 'Evet' : 'Hayır',
              'Kullanıcı Adı': item.UserName,
              Şirket: optionList.companyOptions.find(com => {
                return +com.value === +item.Company
              })?.label,
              IMEI: item.IMEI ?? "-",
              'Silindi': item.IsDeleted ? 'Evet' : 'Hayır',
              'Durumu': item.Cancelled ? 'İptal Edildi' : item.IsDeleted ? 'İptal Edildi' : 'Kayıtlı',
            })
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSXVDFMultipleColumns(data, 'Kredi Kartı Hareketlerim', 'F,H')
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  const columns = useMemo(
    () => [
      { Header: 'İşlemler', accessor: 'col1', width: 100 },
      { Header: 'İşlem Tarihi', accessor: 'col2' },
      { Header: 'İşlem No', accessor: 'col3', width: 150 },
      { Header: 'İşlem Tipi', accessor: 'col4', width: 165 },
      { Header: 'Banka', accessor: 'col5' },
      { Header: 'Adı Soyadı', accessor: 'col6' },
      { Header: 'Toplam Tutar', accessor: 'col7' },
      { Header: 'Taksit', accessor: 'col8', width: 80 },
      { Header: 'Taksit Tutar', accessor: 'col9' },
      { Header: 'Kur Tipi', accessor: 'cur' },
      { Header: 'Kur Bilgisi', accessor: 'curData' },
      { Header: 'Ödenen', accessor: 'realPrice' },
      { Header: 'Doküman No', accessor: 'col10' },
      { Header: '3D', accessor: 'col11', width: 70 },
      { Header: 'Kullanıcı Adı', accessor: 'col12' },
      { Header: 'Şirket', accessor: 'col13', width: 165 },
      { Header: 'IMEI', accessor: 'imei', width: 165 },
      { Header: 'Silindi', accessor: 'col14', width: 165 },
      { Header: 'Durumu', accessor: 'col15', width: 165 },
      //{ Header: 'Sipariş No', accessor: 'col14'},
    ],
    []
  )

  const data = useMemo(
    () =>
      transactions.map((t: CreditCardTransactionsResponse) => ({
        col1: (
          <div className='d-flex gap-1'>
            {/* <IPPrintButton
              buttonText=""
              onClick={() => {
                handlePrint(t.DocumentNumber, t.Company, t.TransactionNumber);
              }}
            /> */}
            <div className='tableIcon' title='Yazdır' style={{
              color: 'black',
              fontSize: '30px',
              backgroundColor: 'transparent'
            }} onClick={
              () => {
                handlePrint(t.DocumentNumber, t.Company, t.TransactionNumber, false);
              }
            }>
              <i className="fa fa-print" style={{
                opacity: 0.8,
                fontSize: '21px'
              }}></i>
            </div>
            <div className='tableIcon' title='PDF İndir' style={{
              color: 'green',
              fontSize: '25px',
              backgroundColor: 'transparent'

            }} onClick={
              () => {
                handleDownload(t.DocumentNumber, t.Company, t.TransactionNumber, false);
              }
            }>
              <i className="fas fa-file-download" style={{
                opacity: 0.8,
                fontSize: '22px'
              }}></i>
            </div>
            {/* <div
              className='tableIcon edit'
              title='Yazdır'
              onClick={() => creditCardPrintPdfDetail(t.DocumentNumber, t.Company, t.TransactionNumber)}
            >
              <i className='fa fa-file-pdf'></i>
            </div> */}
            <div
              className='tableIcon delete'
              title={
                t.CancelEmail && !t.IsDeleted
                  ? 'İşlem iptal Maili Gönderildi'
                  : t.IsDeleted
                    ? 'İşleminiz iptal edilmiştir'
                    : 'İşlemi İptal Et'
              }
              style={{ backgroundColor: t.IsDeleted ? 'gray' : '', cursor: t.IsDeleted ? 'default' : '' }}
              onClick={() => {
                if (t.IsDeleted) {
                  return Swal.fire({
                    icon: 'warning',
                    title: 'Uyarı',
                    text: 'İşleminiz zaten iptal edildi!',
                    confirmButtonText: 'Tamam',
                  })
                }
                if (t.CancelEmail)
                  return Swal.fire({
                    icon: 'warning',
                    title: 'Uyarı',
                    text: 'İptal maili zaten gönderildi! Tekrar göndermek istediğinize emin misiniz?',
                    confirmButtonText: 'Evet',
                    showCancelButton: true,
                    cancelButtonText: 'İptal',
                  }).then(a => {
                    if (a.isConfirmed) {
                      sendCreditCardCancellationEmail(t.DocumentNumber, t.Company, t.TransactionNumber)
                    }
                  })
                sendCreditCardCancellationEmail(t.DocumentNumber, t.Company, t.TransactionNumber)
              }}
            >
              {t.CancelEmail && (
                <span
                  className={css`
                    position: absolute;
                    top: 0;
                    right: -3px;
                    font-size: 12px;
                    line-height: 10px;
                    z-index: 5;
                  `}
                >
                  ✅
                </span>
              )}
              <i className='icon-mail'></i>
            </div>
          </div>
        ),
        col2: new Intl.DateTimeFormat('tr-TR').format(new Date(t.TransactionDate)),
        col3: t.TransactionNumber,
        col4: t.TransactionType,
        col5: t.BankName,
        col6: t.CCName,
        col7: t.TotalPrice,
        col8: t.Installment,
        col9: t.InstallmentPrice,
        col10: t.DocumentNumber,
        col11: t.ThreedPaymentState ? 'Evet' : 'Hayır',
        col12: t.UserName,
        col14: t.IsDeleted ? 'Evet' : 'Hayır',
        imei: t.IMEI,
        col15: t.Cancelled ? 'İptal Edildi' : 'Kayıtlı',
        col13: optionList.companyOptions.find(com => {
          return +com.value === +t.Company
        })?.label,
        cur: t.Currency ?? "TRY",
        realPrice: <div style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>{t.RealPrice ?? "-"}</div>,
        curData: t.CurrencyData ? (
          <div style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>
            {t.Currency === "USD" && (
              <>
                <span style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>
                  USD:{t.CurrencyData.Usd
                    ? parseFloat(t.CurrencyData.Usd.replace(',', '.')).toFixed(4)
                    : "0.0000"}
                </span>
                <br />
              </>
            )}

            {t.Currency === "EUR" && (
              <span style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>
                EUR:{t.CurrencyData.Eur
                  ? parseFloat(t.CurrencyData.Eur.replace(',', '.')).toFixed(4)
                  : "0.0000"}
              </span>
            )}

            {t.Currency === "TL" && (
              <>
                <span style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>
                  -
                </span>
                <br />
              </>
            )}
          </div>
        ) : <span style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>-</span>

        // col14: t.OrderNumber,
      })),
    [transactions]
  )

  const basketColumns = useMemo(
    () => [
      { Header: 'İşlemler', accessor: 'bCol0', width: 150 },
      { Header: 'İşlem Tarihi', accessor: 'bCol2' },
      { Header: 'Sipariş No', accessor: 'bCol1', width: 150 },
      { Header: 'Referans No', accessor: 'bCol3' },
      { Header: 'Banka', accessor: 'bCol4' },
      { Header: 'Kart Sahibi', accessor: 'bCol7' },
      { Header: 'Tutar', accessor: 'bCol11' },
      { Header: 'Taksit', accessor: 'bCol10', width: 80 },
      { Header: 'Ödeme Yöntemi', accessor: 'bCol6' },
      { Header: 'Şirket', accessor: 'bCol5', width: 165 },
    ],
    []
  )

  const basketData = useMemo(
    () =>
      basketTransactions.map((b: BasketTransactionResponse) => ({
        bCol0: (
          <div className='d-flex gap-1'>
            {/* <IPPrintButton
              buttonText=""
              onClick={() => {
                handlePrint(t.DocumentNumber, t.Company, t.TransactionNumber);
              }}
            /> */}
            <div className='tableIcon' title='Yazdır' style={{
              color: 'black',
              fontSize: '30px',
              backgroundColor: 'transparent'
            }} onClick={
              () => {
                handlePrint(b.BIY, b.Sirket, b.SiparisNo, true);
              }
            }>
              <i className="fa fa-print" style={{
                opacity: 0.8,
                fontSize: '21px'
              }}></i>
            </div>
            <div className='tableIcon' title='PDF İndir' style={{
              color: 'green',
              fontSize: '25px',
              backgroundColor: 'transparent'

            }} onClick={
              () => {
                handleDownload(b.BIY, b.Sirket, b.SiparisNo, true);
              }
            }>
              <i className="fas fa-file-download" style={{
                opacity: 0.8,
                fontSize: '22px'
              }}></i>
            </div>
          </div>
        ),
        bCol1: b.SiparisNo,
        bCol2: b.IslemTarihi ? new Intl.DateTimeFormat('tr-TR').format(new Date(b.IslemTarihi)) : '-',
        bCol3: b.BIY,
        bCol4: b.Banka,
        bCol5: b.Sirket,
        bCol6: b.OdemeYontemi,
        bCol7: b.KartSahibi,
        bCol10: b.Taksit,
        bCol11: formatCurrencyTemlik(b.Tutar) + " ₺",
      })),
    [basketTransactions]
  )

  const placeholder = (value: string) => (
    <div
      style={{
        color: '#000',
        fontSize: '12px',
        fontWeight: '600',
      }}
    >
      {value}
    </div>
  )

  return (
    <div className='container-fluid'>
      <div className='row mb-3'>
        <div className='col-12 col-md-2 mb-3'>
          <InputCampaign
            type='date'
            id='StartDate'
            name='StartDate'
            label={'Başlangıç Tarihi'}
            value={toDateTimeLocal(startDate)}
            onChange={e => getDate(e.target.value, 'Start')}
            isActive
          />
        </div>
        <div className='col-12 col-md-2 mb-3'>
          <InputCampaign
            type='date'
            id='EndDate'
            name='EndDate'
            label={'Bitiş Tarihi'}
            value={toDateTimeLocal(endDate)}
            onChange={e => getDate(e.target.value, 'End')}
            isActive
          />
        </div>
        <div className='col-12 col-md-3 mb-3'>
          <IPSelectBox
            options={optionList.companyOptions}
            value={companyValue}
            isDisabled={optionList?.companyOptions?.length === 1}
            onChangeSingle={option => {
              setCompanyValue(option)
            }}
            placeholder={placeholder('Firma')}
            isClearable
          />
        </div>

        <div className='col-12 col-md-2 mb-3'>
          <IPButton text='Göster' onClick={creditCardTransactions} />
        </div>
        <div className='col-12 col-md-auto mb-3 ms-auto d-flex align-items-center gap-2'>
          <span style={{ whiteSpace: 'nowrap' }}>Excel:</span>
          <button
            type='button'
            style={{
              border: '1px solid #2e7d32',
              borderRadius: 0,
              width: '40px',
              height: '40px',
              backgroundColor: 'white',
              padding: 0,
            }}
            onClick={excelButton}
            className='btn text-capitalize background-white-important d-flex align-items-center justify-content-center'
          >
            <i
              className='fas fa-file-excel'
              style={{
                fontSize: '18px',
                color: '#2e7d32',
              }}
            ></i>
          </button>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <h5 className='mb-3'>Ödeme Hareketleri</h5>
          {transactions.length > 0 ? <Table columns={columns} data={data} currentPage={0} /> : 'Veri bulunamadı.'}
        </div>
      </div>
      <div className='row mt-4'>
        <div className='col'>
          <h5 className='mb-3'>Sepet Hareketleri</h5>
          {basketTransactions.length > 0 ? (
            <Table columns={basketColumns} data={basketData} currentPage={0} />
          ) : (
            'Veri bulunamadı.'
          )}
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(CreditCardOperations)
